"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PopperMenuDefaultProps = exports.PopperMenu = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactPopper = require("react-popper");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var PopperMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(PopperMenu, _React$Component);

  var _super = _createSuper(PopperMenu);

  function PopperMenu(props) {
    var _this;

    _classCallCheck(this, PopperMenu);

    _this = _super.call(this, props);
    _this.popperRef = null;

    _this.outsideClickListener = function (event) {
      // if the click event target is not inside the popper ref,
      // close the popper and remove the outside click listener
      if (_this.popperRef !== null && !_this.popperRef.contains(event.target)) {
        _this.setState({
          isPopperVisible: false
        }, function () {
          _this.destroyPopperListener();
        });
      }
    };

    _this.createPopperListener = function () {
      document.addEventListener('click', _this.outsideClickListener);
    };

    _this.destroyPopperListener = function () {
      document.removeEventListener('click', _this.outsideClickListener);
    };

    _this.innerRefHandler = function (popperRef) {
      _this.popperRef = popperRef;
    };

    _this.handleToggleClick = function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (!_this.props.disabled) {
        _this.togglePopperVisibility();
      }
    };

    _this.togglePopperVisibility = function () {
      var isPopperVisible = _this.state.isPopperVisible;
      var nextVisibility = !isPopperVisible;

      _this.setState({
        isPopperVisible: nextVisibility
      }, function () {
        // create or destroy listener after state update
        if (nextVisibility) {
          _this.createPopperListener();
        } else {
          _this.destroyPopperListener();
        }
      });
    };

    _this.renderWrappedChildren = function () {
      var children = _this.props.children;
      return _react.default.Children.map(children, function (child) {
        var itemOnClick = _lodash.default.get(child, ['props', 'onClick'], function () {});

        var wrappedOnClick = function wrappedOnClick(e) {
          e.preventDefault();

          if (_this.props.autoCloseOnClick) {
            _this.togglePopperVisibility();
          }

          itemOnClick();
        };

        return _react.default.cloneElement(child, {
          onClick: wrappedOnClick
        });
      });
    };

    _this.state = {
      isPopperVisible: false
    };
    return _this;
  } // Event listener used to hide the popper on outside click


  _createClass(PopperMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          referenceElement = _this$props.referenceElement,
          menuPlacement = _this$props.menuPlacement,
          disabled = _this$props.disabled,
          classNames = _this$props.classNames,
          classNamesPopperContent = _this$props.classNamesPopperContent,
          arrow = _this$props.arrow;
      var isPopperVisible = this.state.isPopperVisible;

      var referenceElementClasses = _defineProperty({
        // eslint-disable-next-line quote-props
        'popper__toggle': true,
        'popper__toggle--open': isPopperVisible,
        'popper__toggle--closed': !isPopperVisible,
        'popper__toggle--disabled': disabled,
        'popper__toggle--hasarrow': arrow
      }, "popper__toggle--menu-".concat(menuPlacement), true);

      var popperContentClasses = (0, _classnames.default)(arrow, 'popper__content', classNamesPopperContent); // ADA compliant - allow an enter key to act like a click.

      var _handleKeyPress = function _handleKeyPress(target) {
        if (target.key === 'Enter') {
          target.currentTarget.click();
        }
      };

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "popper"
      }, /*#__PURE__*/_react.default.createElement(_reactPopper.Manager, null, /*#__PURE__*/_react.default.createElement(_reactPopper.Reference, null, function (_ref) {
        var ref = _ref.ref;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)(referenceElementClasses),
          role: "button",
          tabIndex: 0,
          ref: ref,
          onClick: _this2.handleToggleClick,
          onKeyDown: _handleKeyPress,
          "aria-label": "Click to open menu"
        }, referenceElement);
      }), isPopperVisible ? /*#__PURE__*/_react.default.createElement(_reactPopper.Popper, {
        placement: menuPlacement,
        innerRef: this.innerRefHandler,
        eventsEnabled: false,
        modifiers: {
          preventOverflow: {
            enabled: false
          },
          flip: {
            enabled: false
          },
          hide: {
            enabled: false
          },
          computeStyle: {
            y: 'left'
          }
        }
      }, function (_ref2) {
        var ref = _ref2.ref,
            style = _ref2.style,
            placement = _ref2.placement,
            arrowProps = _ref2.arrowProps;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: popperContentClasses,
          ref: ref,
          style: style,
          "data-placement": placement
        }, arrow && /*#__PURE__*/_react.default.createElement("div", {
          className: "popper__arrow",
          ref: arrowProps.ref,
          style: arrowProps.style
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "popper__arrow-inner"
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)(classNames, 'popper__menu')
        }, _this2.renderWrappedChildren()));
      }) : null));
    }
  }]);

  return PopperMenu;
}(_react.default.Component);

exports.PopperMenu = PopperMenu;
PopperMenu.propTypes = {
  disabled: _propTypes.default.bool.isRequired,
  arrow: _propTypes.default.bool.isRequired,
  autoCloseOnClick: _propTypes.default.bool.isRequired,
  classNames: _propTypes.default.any.isRequired,
  classNamesPopperContent: _propTypes.default.any.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]).isRequired,
  referenceElement: _propTypes.default.node.isRequired,
  menuPlacement: _propTypes.default.oneOfType([_propTypes.default.oneOf(['bottom-end']), _propTypes.default.oneOf(['bottom']), _propTypes.default.oneOf(['bottom-start'])]).isRequired
};
var PopperMenuDefaultProps = {
  arrow: false,
  disabled: false,
  classNames: '',
  classNamesPopperContent: '',
  autoCloseOnClick: true
};
exports.PopperMenuDefaultProps = PopperMenuDefaultProps;
PopperMenu.defaultProps = PopperMenuDefaultProps;
var _default = PopperMenu;
exports.default = _default;